var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisibility(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1467_3701",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1467_3701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.50255 12.3318C10.3996 12.3318 11.1616 12.0178 11.7883 11.3899C12.415 10.762 12.7284 9.99948 12.7284 9.10239C12.7284 8.2053 12.4144 7.44338 11.7865 6.81665C11.1586 6.18991 10.3961 5.87654 9.49899 5.87654C8.6019 5.87654 7.83999 6.1905 7.21325 6.81843C6.58651 7.44635 6.27315 8.20886 6.27315 9.10595C6.27315 10.003 6.58711 10.765 7.21503 11.3917C7.84296 12.0184 8.60546 12.3318 9.50255 12.3318ZM9.50077 11.2417C8.90702 11.2417 8.40233 11.0339 7.98671 10.6182C7.57108 10.2026 7.36327 9.69792 7.36327 9.10417C7.36327 8.51042 7.57108 8.00573 7.98671 7.5901C8.40233 7.17448 8.90702 6.96667 9.50077 6.96667C10.0945 6.96667 10.5992 7.17448 11.0148 7.5901C11.4305 8.00573 11.6383 8.51042 11.6383 9.10417C11.6383 9.69792 11.4305 10.2026 11.0148 10.6182C10.5992 11.0339 10.0945 11.2417 9.50077 11.2417ZM9.50176 14.6458C7.68132 14.6458 6.02258 14.1437 4.52554 13.1393C3.0285 12.1351 1.92624 10.79 1.21875 9.10417C1.92624 7.41831 3.0281 6.07327 4.52435 5.06904C6.02074 4.06468 7.67921 3.5625 9.49978 3.5625C11.3202 3.5625 12.979 4.06468 14.476 5.06904C15.973 6.07327 17.0753 7.41831 17.7828 9.10417C17.0753 10.79 15.9734 12.1351 14.4772 13.1393C12.9808 14.1437 11.3223 14.6458 9.50176 14.6458ZM9.50077 13.4583C10.9917 13.4583 12.3607 13.0658 13.6075 12.2807C14.8544 11.4957 15.8077 10.4368 16.4674 9.10417C15.8077 7.77153 14.8544 6.71267 13.6075 5.9276C12.3607 5.14253 10.9917 4.75 9.50077 4.75C8.0098 4.75 6.64087 5.14253 5.394 5.9276C4.14712 6.71267 3.19383 7.77153 2.5341 9.10417C3.19383 10.4368 4.14712 11.4957 5.394 12.2807C6.64087 13.0658 8.0098 13.4583 9.50077 13.4583Z",
    fill: "#001E40",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/visibility.e7b002d9defb0f01e5307a5046d3676e.svg";
export { ForwardRef as ReactComponent };